export default __webpack_public_path__ + "static/media/subLogo.2964349e.svg";